import { QueryConfig } from "./Queries";

export type LocationApplicationsBundleInput = {
  applicationBundles: {
    applicationBundleId: string;
    applyToDescendants: boolean;
  }[];
  locationId: string;
};

export const locationApplicationsBundleMutation = (
  input: LocationApplicationsBundleInput
): QueryConfig => {
  const query = `mutation handleAddApplicationBundlesToLocation($locationApplicationBundles: ApplicationBundlesForLocationInput!) {
            setAssociatedApplicationBundlesForLocation(input: $locationApplicationBundles)
        }`;
  return {
    query: query,
    variables: {
      locationApplicationBundles: input,
    },
  };
};
